"use strict";

exports.__esModule = true;
var _DeviceListScreenPlantTwin = require("./DeviceListScreenPlantTwin");
Object.keys(_DeviceListScreenPlantTwin).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceListScreenPlantTwin[key]) return;
  exports[key] = _DeviceListScreenPlantTwin[key];
});